import Vue from "vue";
import Vuex from "vuex";

import * as app from "./modules/app";
import * as auth from "./modules/auth";
import * as dashboard from "./modules/dashboard";
import * as userInfo from "./modules/userInfo";
import * as userManagement from "./modules/userManagement";
import * as company from "./modules/company";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    barColor: "rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)",
    barImage: "/img/01.jpg",
    drawer: null,
    overlay: false
  },
  getters: {
    getOverlay(state) {
      return state.overlay;
    }
  },
  mutations: {
    SET_BAR_IMAGE(state, payload) {
      state.barImage = payload;
    },
    SET_DRAWER(state, payload) {
      state.drawer = payload;
    },
    SET_OVERLAY(state, payload) {
      state.overlay = payload;
    }
  },
  actions: {},
  modules: {
    app,
    auth,
    dashboard,
    userInfo,
    userManagement,
    company,


  }
});
